import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    accessToken: '',
    refreshToken: '',
    info: JSON.parse(localStorage.getItem('schedulerLoggedInUser')),
    role: 'public',
  },
  reducers: {
    setInfo: (state, action) => {
      state.info = action.payload;
      localStorage.setItem('schedulerLoggedInUser', JSON.stringify(action.payload));
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      localStorage.setItem('access', action.payload);
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
      localStorage.setItem('211refresh', action.payload);
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
  },
});

export const { setAccessToken, setInfo, setRole, setRefreshToken } = userSlice.actions;
export default userSlice.reducer;
